module.exports = {
  REPORT_LOAD_DATA: 'REPORT_LOAD_DATA',
  REPORT_LOAD_DATA_SUCCESS: 'REPORT_LOAD_DATA_SUCCESS',
  REPORT_LOAD_DATA_FAILURE: 'REPORT_LOAD_DATA_FAILURE',
  REPORT_LOAD_DATA_CANCELED: 'REPORT_LOAD_DATA_CANCELED',
  REPORT_CLEAR_DATA: 'REPORT_CLEAR_DATA',
  REPORT_DOWNLOAD_RESULT_REQUEST: 'REPORT_DOWNLOAD_RESULT_REQUEST',
  REPORT_DOWNLOAD_RESULT_SUCCESS: 'REPORT_DOWNLOAD_RESULT_SUCCESS',
  REPORT_DOWNLOAD_RESULT_FAILURE: 'REPORT_DOWNLOAD_RESULT_FAILURE',
  REPORT_CUSTOM_FILTER_UPDATE: 'REPORT_CUSTOM_FILTER_UPDATE',
  REPORT_CUSTOM_FILTER_CLEAR: 'REPORT_CUSTOM_FILTER_CLEAR',
  REPORT_SORTING_CHANGE: 'REPORT_SORTING_CHANGE',
  REPORT_FILTERING_CHANGE: 'REPORT_FILTERING_CHANGE',
  REPORT_MODE_CHANGE: 'REPORT_MODE_CHANGE',
  CHANGE_ASYNC: 'CHANGE_ASYNC',
  CANCEL_REPORT_REQUEST: 'CANCEL_REPORT_REQUEST',
  CANCEL_REPORT_SUCCESS: 'CANCEL_REPORT_SUCCESS',
  CANCEL_REPORT_FAILURE: 'CANCEL_REPORT_FAILURE',
  SWITCH_TO_ASYNC_REPORT_REQUEST: 'SWITCH_TO_ASYNC_REPORT_REQUEST',
  SWITCH_TO_ASYNC_REPORT_SUCCESS: 'SWITCH_TO_ASYNC_REPORT_SUCCESS',
  SWITCH_TO_ASYNC_REPORT_FAILURE: 'SWITCH_TO_ASYNC_REPORT_FAILURE',
  SWITCH_TO_ASYNC_ENABLED_REQUEST: 'SWITCH_TO_ASYNC_ENABLED_REQUEST',
  SWITCH_TO_ASYNC_ENABLED_SUCCESS: 'SWITCH_TO_ASYNC_ENABLED_SUCCESS',
  SWITCH_TO_ASYNC_ENABLED_FAILURE: 'SWITCH_TO_ASYNC_ENABLED_FAILURE',
  CANCEL_REPORT_ENABLED_REQUEST: 'CANCEL_REPORT_ENABLED_REQUEST',
  CANCEL_REPORT_ENABLED_SUCCESS: 'CANCEL_REPORT_ENABLED_SUCCESS',
  CANCEL_REPORT_ENABLED_FAILURE: 'CANCEL_REPORT_ENABLED_FAILURE',
};
